import { orchestrator } from 'satcheljs';
import { tryDarkMode } from 'owa-whats-new/lib/actions/tryDarkMode';
import { toggleCharm } from 'owa-header-store';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
export default orchestrator(tryDarkMode, function () {
    isControlFeatureEnabled('fwk-o365shellheader')
        ? window.O365Shell.FlexPane.OpenFlexPaneForProvider('OwaSettings')
        : toggleCharm(4 /* SettingsCharm */);
});
//# sourceMappingURL=showQuickOptions.js.map